import { render, staticRenderFns } from "./EditStyle.vue?vue&type=template&id=230b3418&scoped=true&"
import script from "./EditStyle.vue?vue&type=script&lang=js&"
export * from "./EditStyle.vue?vue&type=script&lang=js&"
import style0 from "./EditStyle.vue?vue&type=style&index=0&id=230b3418&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "230b3418",
  null
  
)

export default component.exports